import { render, staticRenderFns } from "./SafetyEquipment.vue?vue&type=template&id=719c0867&scoped=true"
import script from "./SafetyEquipment.vue?vue&type=script&lang=js"
export * from "./SafetyEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719c0867",
  null
  
)

export default component.exports